const updates = [
  {
    date: '2026-07-31',
    title: '《流浪地球3》高清资源已上线',
    desc: '郭帆导演科幻巨制第三部，1080P高清画质，含中文字幕，现已加入科幻专题合集。',
    tag: '新片上线',
  },
  {
    date: '2026-07-30',
    title: '暑期档专题页面上线',
    desc: '2026暑期档最全观影指南已整理完成，涵盖动作、动画、悬疑等多个分类。',
    tag: '专题更新',
  },
  {
    date: '2026-07-28',
    title: '服务器全面升级完成',
    desc: '播放线路优化升级，加载速度提升40%，全网高清不缓冲体验更进一步。',
    tag: '系统公告',
  },
  {
    date: '2026-07-26',
    title: '韩剧专区新增8部热播剧',
    desc: '包括《恶鬼2》《财阀家的小儿子2》等热门韩剧同步更新中。',
    tag: '内容更新',
  },
  {
    date: '2026-07-24',
    title: '豆瓣高分电影专栏上线',
    desc: '收录豆瓣评分8.5以上的高分佳片，按类型分类，方便影迷查找经典。',
    tag: '新功能',
  },
  {
    date: '2026-07-22',
    title: '动画电影专题扩容',
    desc: '新增宫崎骏全系列、皮克斯经典等30余部动画电影，适合全年龄段观看。',
    tag: '内容更新',
  },
  {
    date: '2026-07-20',
    title: '视频播放器优化',
    desc: '新增倍速播放、记忆进度功能，提升观影体验，支持手机端手势操作。',
    tag: '功能升级',
  },
  {
    date: '2026-07-18',
    title: '悬疑推理专题重磅上线',
    desc: '精心挑选50部高分悬疑片，从经典本格推理到现代心理惊悚一网打尽。',
    tag: '专题更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-foreground-500 text-sm">蘑菇影院最新影片上线、功能升级与平台公告</p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-200"></div>
            <div className="space-y-8">
              {updates.map((update, i) => (
                <div key={i} className="relative pl-10 md:pl-12">
                  <div className={`absolute left-2 md:left-3 top-1 w-5 h-5 rounded-full border-2 ${
                    i === 0 ? 'border-primary-500 bg-primary-100' : 'border-background-300 bg-background-100'
                  }`}></div>
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400">{update.date}</span>
                    <span className="inline-block px-2 py-0.5 bg-accent-100/80 text-accent-700 text-xs font-medium rounded-full">
                      {update.tag}
                    </span>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1">{update.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{update.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}